<template>
  <div style="font-size:12px;">
    <div>{{this.$store.state.question.sections[indexSection].onglet}}{{" "}}{{indexSection+1}}{{"/"}}{{this.$store.state.question.sections.length}}</div>
    <!-- sections -->
    <div
      style="font-weight:bold;"
      v-show="showInputEntitled"
      @click="showInputEntitled=!showInputEntitled;focus()"
    ><span>{{this.$store.state.question.sections[indexSection].entitled}}</span>
    <span>{{" "}}<b-icon pack="fa" icon="pencil-alt" size="is-smallest"></b-icon></span>
    </div>
    <div v-show="!showInputEntitled">
      <input
        style="width:220px"
        maxlength="255"
        ref="entitled"
        :value="this.$store.state.question.sections[indexSection].entitled"
        @blur="showInputEntitled =!showInputEntitled;updateEntitled($event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChampsSection',
  props: {
    indexSection: Number,
    required: true
  },
  data () {
    return {
      showInputEntitled: true
    }
  },
  methods: {
    focus () {
      this.$refs.entitled.focus()
    },
    updateEntitled (e, index) {
      this.$store.commit('UDAPTE_SECTION_ENTITLED', {
        updateEntitled: e.target.value,
        indexSection: this.indexSection
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/section/ChampsSection.vue